// ModalProvider.js
import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useLoadScript } from '@react-google-maps/api';
import GoogleMapContext from './GoogleMapContext';
import { toasterMsg } from '../Toaster/Toaster';

const libraries = ['places', 'geometry', 'drawing', 'visualization'];
function GoogleMapProvider({ children }) {
  const [startCountry, setStartCountry] = useState(null);
  const [startZipCode, setStartZipcode] = useState(null);
  const [endCountry, setEndCountry] = useState(null);
  const [endZipCode, setEndZipcode] = useState(null);
  const [currentCoordinates, setCurrentCoordinates] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const mapRef = useRef(null);

  const placesServiceRef = useRef(null);
  const autocompleteServiceRef = useRef(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY, // Replace with your API key
    libraries,
    id: 'google-map-script',
  });

  useEffect(() => {
    // Check if Geolocation API is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log('position.coordsposition.coords', position?.coords);
          setCurrentCoordinates({ lat: latitude, lng: longitude });
        },
        (error) => {
          setCurrentCoordinates(null);
        },
      );
    } else {
      setCurrentCoordinates(null);
    }
  }, []);

  if (loadError) {
    toasterMsg('Google script loading failed', 'danger');
  }
  useEffect(() => {
    if (isLoaded && !placesServiceRef?.current && !autocompleteServiceRef?.current) {
      const dummyMapDiv = document.createElement('div');
      mapRef.current = new window.google.maps.Map(dummyMapDiv);
      placesServiceRef.current = new window.google.maps.places.PlacesService(mapRef.current);
      autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();
      setIsReady(true);
    }
  }, [isLoaded]);

  const contextValue = useMemo(
    () => ({
      startCountry,
      startZipCode,
      endCountry,
      endZipCode,
      setStartCountry,
      setStartZipcode,
      setEndCountry,
      setEndZipcode,
      currentCoordinates,
      googleScriptLoaded: isLoaded,
      isReady,
      placesService: placesServiceRef.current,
      autocompleteService: autocompleteServiceRef.current,
    }),
    [
      isLoaded,
      startCountry,
      startZipCode,
      endCountry,
      endZipCode,
      currentCoordinates,
      setStartCountry,
      setStartZipcode,
      setEndCountry,
      setEndZipcode,
      placesServiceRef.current,
      autocompleteServiceRef.current,
    ],
  );

  return <GoogleMapContext.Provider value={contextValue}>{children}</GoogleMapContext.Provider>;
}

export default GoogleMapProvider;
